// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__LhJtv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Layout.css
// module id = 88
// module chunks = 0